module.exports = __webpack_public_path__ + "img/curation.1bcd818e.png";